module.exports = __webpack_public_path__ + "img/testconfig.eb8a7929.svg";